class KukunInputRadio {
    constructor(inputsContainer, parameters) {
        this.container = inputsContainer;
        this.parameters = parameters;
        this._addParameters();
        this._loadEvents();
    }

    _loadEvents() {
        if (this.container.childElementCount <= 2) {
            this.container.classList.add('buttonsView');
        } else {
            this.container.classList.add('ListView');
        }
    }

    _addParameters() {
        this.parameters.width ? this.container.style.width = this.parameters.width : '';

        if (this.parameters.maxWidth) {
            for (let child of this.container.children) {
                child.children[0].style.maxWidth = this.parameters.maxWidth;
            }
        }
    }
}

let modalInstances = [];

const init = (inputsContainer, containerParameters) => {
    if (inputsContainer) {
        if (typeof inputsContainer.length == 'undefined') {
            const htmlElement = inputsContainer;
            const parameters = containerParameters;
            modalInstances = new KukunInputRadio(htmlElement, parameters);
        } else {
            for (let i = 0; i < inputsContainer.length; i++) {
                const htmlElement = inputsContainer[i];
                let modalInstance = new KukunInputRadio(htmlElement);
                modalInstances.push(modalInstance);
            }
        }
    }

    return modalInstances;
}


export {
    init
};